import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import TestPage from "./pages/TestPage";
import {useState} from "react";
import LoyaltyProgramsPage from "./pages/dashboard/LoyaltyProgramsPage";
import CustomersPage from "./pages/dashboard/CustomersPage";
import AnalyticsPage from "./pages/dashboard/AnalyticsPage";
import PromotionsPage from "./pages/dashboard/PromotionsPage";
import CommunicationsPage from "./pages/dashboard/CommunicationsPage";
import SettingsPage from "./pages/dashboard/SettingsPage";
import MyAccountPage from "./pages/dashboard/MyAccountPage";
import LoginPage from "./pages/auth/LoginPage";
import SignUpPage from "./pages/auth/SignUpPage";
import BusinessRegistrationPage from "./pages/registration/BusinessRegistrationPage";
import LoyaltyProgramSetupPage from "./pages/registration/LoyaltyProgramSetupPage";
import ClientRedeemRewardsPage from "./pages/client/ClientRedeemRewardsPage";
import HomePage from "./pages/dashboard/HomePage";
import BusinessScanToEarnPage from "./pages/checkout/BusinessScanToEarnPage";
import ClientDashboardPage from "./pages/client/ClientDashboardPage ";
import BusinessCheckoutPage from "./pages/checkout/BusinessCheckoutPage";
import LandingPage from "./pages/landing/LandingPage";
import TestOnePage from "./pages/TestOnePage";
import AccountVerificationPage from "./pages/registration/BusinessVerificationPendingPage";
import BusinessVerificationPendingPage from "./pages/registration/BusinessVerificationPendingPage";

function App() {
 
  return (
      <BrowserRouter>
          <LandingLayout />
          <AuthLayout />
          <DashboardLayout />
          <ClientDashboard />
          <CheckoutLayout />
          <Routes>
              <Route path="/test" element={<TestPage />} />
          </Routes>
      </BrowserRouter>
  );
}

const LandingLayout = () => {
    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/test-one" element={<TestOnePage />} />
        </Routes>
    )
}

const AuthLayout = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/sign-up" element={<SignUpPage />} />
            <Route path="/register-business/:userId" element={<BusinessRegistrationPage />} />
            <Route path="/register-program/:userId/:businessId" element={<LoyaltyProgramSetupPage />} />
            <Route path="/business-verification/:userId/:businessId" element={<BusinessVerificationPendingPage />} />
        </Routes>
    )
}

const DashboardLayout = () => {
    return (
        <Routes>
            <Route path="/dashboard/:userId/:businessId/home" element={<HomePage />} />
            <Route path="/dashboard/:userId/:businessId/programs" element={<LoyaltyProgramsPage />} />
            <Route path="/dashboard/:userId/:businessId/customers" element={<CustomersPage />} />
            <Route path="/dashboard/:userId/:businessId/analytics" element={<AnalyticsPage />} />
            <Route path="/dashboard/:userId/:businessId/promotions" element={<PromotionsPage />} />
            <Route path="/dashboard/:userId/:businessId/communication" element={<CommunicationsPage />} />
            <Route path="/dashboard/:userId/:businessId/settings" element={<SettingsPage />} />
            <Route path="/dashboard/:userId/:businessId/my-account" element={<MyAccountPage />} />
        </Routes>
    )
}

const CheckoutLayout = () => {
  return (
      <Routes>
          <Route path="/checkout/:userId/:businessId" element={<BusinessCheckoutPage />} />
      </Routes>
  )
}

const ClientDashboard = () => {
    return (
        <Routes>
            <Route path="/dashboard/userid/client/home" element={<ClientDashboardPage navigateTo={"clientDashboard"} />} />
            <Route path="/dashboard/userid/client/redeem" element={<ClientRedeemRewardsPage navigateTo={"clientRedeemRewards"} />} />
        </Routes>
    )
}

export default App;
